import errores, {
  getParamMensajeContratacion
} from "@/config/constants/errores";

describe("Errores", () => {
  it("Errores constantes errores", () => {
    expect(errores).toBeDefined();
    expect(errores).not.toBeNull();
    expect(typeof errores).toBe("object");
  });

  it("Errores constantes getParamMensajeContratacion", () => {
    const errores = ["CLE0534", "CLE0535"];
    const response = getParamMensajeContratacion(errores);
    expect(response).toBe("error-celular");
  });
});
